<eo-search-page
  [formConfig]="formConfig"
  [tableConfig]="tableConfig"
  [searchServ]="searchService"
  [page]="getPage()"
  [pagesize]="getPagesize()"
  [totalCount]="getTotalCount()"
  [loading]="isLoading()"
  [viewModeVisible]="false"
  [menuActions]="[]"
  (search)="onSearch($event)"
  [customFormControls]="{
    hospitalID: hospitalID,
    clinicID: clinicID
  }"
  (clearEvent)="onClearEvent()"
  [initData]="false"
  [collapsed]="false"
>
  <ng-template
    #hospitalID
    let-formGroup="formGroup"
    let-config="config"
    let-styleClass="styleClass"
  >
    <ng-container [formGroup]="formGroup">
      <app-hospital-dropdown
        [label]="config.label"
        [class]="styleClass"
        [config]="config"
        (change)="onHospitalChange($event)"
        formControlName="hospitalID"
      />
    </ng-container>
  </ng-template>
  <ng-template
    #clinicID
    let-formGroup="formGroup"
    let-config="config"
    let-styleClass="styleClass"
  >
    <ng-container [formGroup]="formGroup">
      <app-clinic-dropdown
        [label]="config.label"
        [class]="styleClass"
        [config]="config"
        formControlName="clinicID"
        [hospitalId]="hospitalId"
        [showClear]="tokenData?.clinicId == null"
      />
    </ng-container>
  </ng-template>
</eo-search-page>


<app-surgery-unable-to-contact-form-dialog
  #surgeryUnableToContactFormDialog
  (success)="onTriggerSearch()"
/>